import { ProductId } from 'src/replicant/iap';
import {
  shopBundleGetPackRewardSet,
  shopBundlesGetPack,
} from './match2-shopbundles.getters';
import { MutableState } from 'src/replicant/State';
import * as Match2 from '..';
import {
  CurrencyGrantOpts,
  CurrencyReplicantAPI,
} from 'src/replicant/inventory/inventory.utils';
import {
  PetStarterPackProductId,
  petStarterPackProducts,
} from 'src/replicant/starterpack/starterpack.ruleset';

/**
 * Claim shop bundle rewards, only for shop bundle packs
 * This is not including free and paid gems, as they are given as regular gems rewards,
 * so only extra rewards (darts, bombs, unlimited energy, etc) are handled here.
 */
export function shopBundlesClaimProductRewards(
  state: MutableState,
  productId: ProductId,
  api: CurrencyReplicantAPI,
  opts?: CurrencyGrantOpts,
): void {
  const pack = shopBundlesGetPack(productId);
  if (!pack) return;

  const now = api.date.now();
  const rewards = shopBundleGetPackRewardSet(productId, now);
  Match2.modifiers.grantMatch2Rewards(
    state,
    rewards,
    {
      feature: 'purchase',
      $subFeature: `${productId}`,
    },
    api,
    opts,
  );

  // Mark starter pack as purchased, to prevent it from showing up in the shop again
  if (productId === 'buruburu_starter_pack') {
    if (!state.match2.shopBundles) state.match2.shopBundles = {};
    state.match2.shopBundles.starterPackPurchased = true;
  }

  // Mark pet starter pack as purchased, to prevent it from showing up again
  if (petStarterPackProducts.includes(productId as PetStarterPackProductId)) {
    if (!state.match2.shopBundles) state.match2.shopBundles = {};
    state.match2.shopBundles.petStarterPackPurchased = true;
  }
}
